/**
 * Samstagszustellung im Warenkorb (Lukas, 02.10.2026).
 * Im Checkout gibt es nur noch eine Versandart «Versand». Das Häkchen im Warenkorb legt den
 * versteckten Aufpreis-Artikel «Samstagszustellung» in den Warenkorb (oder nimmt ihn heraus)
 * und setzt das Bestellattribut «Samstagszustellung: Ja», damit der Wunsch auf der Bestellung steht.
 */
(function () {
  'use strict';

  var busy = false;

  function root() { return document.querySelector('[data-pg-cart-section]'); }

  function variantId() {
    var node = root();
    return node ? node.getAttribute('data-pg-saturday-variant') : null;
  }

  function route(path) {
    var base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    if (base.charAt(base.length - 1) !== '/') base += '/';
    return base + path;
  }

  function postJson(path, body) {
    return fetch(route(path), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (response) {
      if (!response.ok) throw new Error('HTTP ' + response.status);
      return response.json();
    });
  }

  function rerender() {
    var node = root();
    if (!node) return Promise.resolve();
    var sectionId = node.getAttribute('data-section-id');
    return fetch(route('cart?section_id=' + encodeURIComponent(sectionId)), { headers: { Accept: 'text/html' } })
      .then(function (response) {
        if (!response.ok) throw new Error('HTTP ' + response.status);
        return response.text();
      })
      .then(function (html) {
        var fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-pg-cart-section]');
        var current = root();
        if (fresh && current) current.replaceWith(fresh);
      });
  }

  function setSaturday(on) {
    var id = variantId();
    if (!id || busy) return Promise.resolve();
    busy = true;
    var updates = {};
    updates[id] = on ? 1 : 0;
    return postJson('cart/update.js', { updates: updates, attributes: { Samstagszustellung: on ? 'Ja' : '' } })
      .then(function (cart) {
        document.dispatchEvent(new CustomEvent('pg:cart-updated', { detail: { cart: cart, source: 'saturday' } }));
        return rerender();
      })
      .finally(function () { busy = false; });
  }

  document.addEventListener('change', function (event) {
    var box = event.target && event.target.closest ? event.target.closest('[data-pg-saturday]') : null;
    if (!box) return;
    var wanted = box.checked;
    box.disabled = true;
    setSaturday(wanted).catch(function () {
      box.checked = !wanted;
      box.disabled = false;
      var status = document.querySelector('[data-pg-cart-status]');
      if (status) status.textContent = box.getAttribute('data-error') || '';
    });
  });

  // Nur noch der Aufpreis im Warenkorb (alle Produkte entfernt) oder mehr als einmal: korrigieren.
  document.addEventListener('pg:cart-updated', function (event) {
    if (busy) return;
    var cart = event.detail && event.detail.cart;
    var id = variantId();
    if (!cart || !id || !Array.isArray(cart.items)) return;
    var saturday = cart.items.filter(function (item) { return String(item.variant_id) === String(id); });
    if (!saturday.length) return;
    var others = cart.items.length - saturday.length;
    var quantity = saturday.reduce(function (sum, item) { return sum + item.quantity; }, 0);
    if (others === 0) setSaturday(false).catch(function () {});
    else if (quantity > 1) setSaturday(true).catch(function () {});
  });
})();
